module.exports = __webpack_public_path__ + "img/portulans.c15326c0.png";